import * as React from 'react';
import Slider, { Range } from 'rc-slider';
import styled from 'styled-components';
import { __ } from 'react-i18n';
import { rem } from 'polished';
import { formatPrice } from '../../../../utilities/index';

interface Props {
  handlePointsChange: (points: number) => void;
  user;
  consumedPoints: number;
  cartPrice: number;
  currency: string;
  pointsAmountRatio?: number;
}

function TrustPointComponent({
  handlePointsChange,
  user,
  consumedPoints = 0,
  cartPrice,
  currency,
  pointsAmountRatio = 0,
}: Props) {
  const [currentValue, setCurrentValue] = React.useState(consumedPoints);
  const { trust_points } = user;

  let maxValue = parseInt(
    Math.ceil(cartPrice / pointsAmountRatio).toFixed(0),
    10,
  );

  if (maxValue > trust_points) {
    maxValue = trust_points;
  }

  const marks = {};
  marks[0] = 0;
  marks[maxValue] = maxValue;

  const onAfterChange = () => {
    handlePointsChange(currentValue);
  };

  return (
    <PurchaseDiscountWrapper>
      <div>
        {__('Vernostné body')} <StyledBold>{trust_points}</StyledBold>
      </div>

      <div>
        {__('Zľava z nákupu')}{' '}
        <StyledBold>
          {currentValue} {__('bodov')} ={' '}
          {formatPrice(pointsAmountRatio * currentValue, '')} {currency}
        </StyledBold>
      </div>
      <SliderWrapper>
        {' '}
        <Slider
          min={0}
          max={maxValue}
          step={1}
          defaultValue={consumedPoints}
          marks={marks}
          onChange={setCurrentValue}
          trackStyle={{ backgroundColor: '#2CC5B7' }}
          dotStyle={{ backgroundColor: '#2CC5B7' }}
          activeDotStyle={{ borderColor: '#2CC5B7' }}
          handleStyle={{
            backgroundColor: 'white',
            border: '2px solid #2CC5B7',
            borderColor: '#2CC5B7',
          }}
          onAfterChange={onAfterChange}
        />
      </SliderWrapper>
    </PurchaseDiscountWrapper>
  );
}

const PurchaseDiscountWrapper = styled.div`
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${rem(16)};
  padding: ${rem(16)};
  border: 1px solid #ccc;
  justify-content: center;
  margin-top: ${rem(8)};
  font-family: ${({ theme }) => theme.font.primary};
  border-radius: ${rem(4)};
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  margin-right: ${rem(32)};
  color: black;
  & > div {
    margin-top: ${rem(5)};
    margin-bottom: ${rem(5)};
  }

  & > div:nth-of-type(2) {
    margin-bottom: ${rem(15)};
  }

  & > div:last-of-type {
    margin-bottom: 0;
  }
`;

const StyledBold = styled.strong`
  font-family: ${({ theme }) => theme.font.primary};
  text-transform: unset;
  margin-left: ${rem(20)};
`;
const SliderWrapper = styled.div`
  padding: 0 ${rem(10)} ${rem(15)} ${rem(10)};
`;

export { TrustPointComponent };
